import React from "react";
import SolutionsItem from "../../components/SolutionItem";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import { Breadcrumb } from 'antd';
import { NavLink } from "react-router-dom";
import './index.css'

const NotContent = () => {
  return (
    <div className="min-h-[400px] text-2xl">
      敬请期待
    </div>
  )
}

const SubSolution = () => {
  const { solutionId } = useParams();
  const subMsg = useFetch(`http://1.94.62.64:9090/myf/getApplicationCases/${solutionId}`)

  return (
    <>
      <div className="mb-6 ml-[300px]">
        <Breadcrumb
          className="mt-[200px] flex items-center"
          items={[
            {
              title: <NavLink to='/' className='mt-0 flex'>
                <span className='text-sm text-blue-600'>
                  主页
                </span>
              </NavLink>

            },
            {
              title: <NavLink to='/solution'>
                <span className='text-sm text-blue-600'>
                  解决方案
                </span>
              </NavLink>
            },
            {
              title: <NavLink
                to={`/solution/${solutionId}`}
              >
                <span className='text-sm'>
                  {`解决方案 ${solutionId}`}
                </span>
              </NavLink>
            }
          ]}
        />
      </div>
      <div className="flex flex-col items-start ml-[300px] mb-[100px]">
        {
          subMsg?.length !== 0 ? subMsg?.map((item) => {
            return (
              <SolutionsItem
                key={item.id}
                id={item.id}
                imgUrl={item.picture}
                header={item.title}
                readMeLink={`/solution/${solutionId}/${item.id}`}
                introText={item.content}
              />
            );
          })
            :
            <NotContent />
        }
      </div>
    </>
  );
};

export default SubSolution;
